import { FirestoreDatabase as Database } from "../../db/common";
import { LISTING_PHOTOS_COLLECTION, ListingPhoto, LISTINGS_COLLECTION } from "../../db/listings";
import { BaseFirestoreServiceWithTimestamp } from "../FirestoreService";

/**
 * Shared Listing Photos Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class ListingPhotosService extends BaseFirestoreServiceWithTimestamp<ListingPhoto> {
    constructor(protected db: Database, protected listingId: string) {
        super(db);
    }
    protected getCollectionPath(): string {
        return `${LISTINGS_COLLECTION}/${this.listingId}/${LISTING_PHOTOS_COLLECTION}`;
    }
}